/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { AxiosError, AxiosInstance } from 'axios';
import { identity } from '@/utils';
import { refreshToken } from '@/services/authentication/refreshToken';
import cookies from '../cookies';
import isAuthorizationError from './utils/isAuthorizationError';
import { AUTH_TOKEN_KEY, options } from '@/hooks/authorization/useToken';

/**
 * Verifica se o erro recebido é um erro de "token expirado".
 */
export function isExpiredTokenError(error: AxiosError<any>) {
  return (
    isAuthorizationError(error) &&
    (error.response?.data?.error === 'expired_token' ||
      error.response?.data?.data?.error === 'expired_token')
  );
}

/**
 * Aplica o interceptador para respostas de token (JWT) expirado. Nele obtemos
 * um token (JWT) novo e o usamos para refazer a requisição.
 */
function handleExpiredTokenError(client: AxiosInstance) {
  client.interceptors?.response.use(identity, async (error) => {
    if (!isExpiredTokenError(error)) {
      return Promise.reject(error);
    }

    const token = await refreshToken({
      currentToken: cookies.get(AUTH_TOKEN_KEY),
      cancelToken: error.config.cancelToken,
    });

    cookies.set(AUTH_TOKEN_KEY, token, options);

    return client({
      ...error.config,
      headers: {
        ...error.config.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  });
}

export default handleExpiredTokenError;
